import { render, staticRenderFns } from "./waring.vue?vue&type=template&id=6027b3e8&scoped=true&"
import script from "./waring.vue?vue&type=script&lang=js&"
export * from "./waring.vue?vue&type=script&lang=js&"
import style0 from "./waring.vue?vue&type=style&index=0&id=6027b3e8&prod&scoped=true&lang=less&"
import style1 from "./waring.vue?vue&type=style&index=1&id=6027b3e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027b3e8",
  null
  
)

export default component.exports